"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconButton = exports.IconButtonContainer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const Icon_1 = require("../Icon");
const styled_components_2 = require("styled-components");
exports.IconButtonContainer = styled_components_1.default.div `
  cursor: pointer;
  display: inline-block;

  svg {
    &:hover {
      color: ${(props) => props.theme.Color.Text.Primary};
    }
  }
`;
const IconButton = ({ Icon, onClick, }) => {
    const theme = (0, styled_components_2.useTheme)();
    return ((0, jsx_runtime_1.jsx)(exports.IconButtonContainer, { children: (0, jsx_runtime_1.jsx)(Icon_1.Icon, Object.assign({ color: theme.Color.Text.Secondary, onClick: onClick }, { children: (0, jsx_runtime_1.jsx)(Icon, {}) })) }));
};
exports.IconButton = IconButton;
